'use client'

import { useHomePage } from '../model/useHomePage'
import ZoomDocNYLandingPage from './variants/zoomdocny/ZoomDocNYLandingPage'
import CubeSanteLandingPage from './variants/cubesante/CubeSanteLandingPage'
import DefaultLanding from './variants/default'

// Dynamic landing page loading based on environment variable
export function HomePage() {
  const { session, variant } = useHomePage()

  // Load variant-specific landing page component
  switch (variant) {
    case 'zoomdocny':
      return <ZoomDocNYLandingPage session={session} />
    case 'cubesante':
      return <CubeSanteLandingPage session={session} />
    case 'default':
    default:
      return <DefaultLanding session={session} />
  }
}
